import { z } from 'zod';
import { paginationQuery } from './common.js';
export const paymentInput = z.object({
    documentId: z.uuid(),
    paidAt: z.iso.date('Fecha inválida'),
    method: z
        .string()
        .regex(/^\d{2}$/)
        .default('04'),
    bankAccountId: z.uuid().nullable().optional(),
    amount: z.coerce.number().positive('El monto debe ser mayor a cero'),
    /**
     * Moneda en que se recibió el pago; si difiere de la del comprobante se convierte con `exchangeRate`
     * (colones por unidad de moneda extranjera). Sin ella se asume la moneda del comprobante.
     */
    currency: z.enum(['CRC', 'USD', 'EUR']).optional(),
    exchangeRate: z.coerce.number().positive().nullable().optional(),
    reference: z.string().trim().max(80).nullable().optional(),
    notes: z.string().trim().max(500).nullable().optional(),
});
export const voidPaymentInput = z.object({ reason: z.string().trim().min(3, 'Indicá el motivo').max(200) });
export const paymentListQuery = paginationQuery.extend({
    from: z.iso.date().optional(),
    to: z.iso.date().optional(),
    method: z
        .string()
        .regex(/^\d{2}$/)
        .optional(),
    customerId: z.uuid().optional(),
    status: z.enum(['active', 'voided', 'all']).default('active'),
});
export const bankAccountInput = z.object({
    name: z.string().trim().min(2, 'Requerido').max(80),
    accountNumber: z.string().trim().max(40).nullable().optional(),
    currency: z.enum(['CRC', 'USD', 'EUR']).default('CRC'),
});
//# sourceMappingURL=payments.js.map